/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterMaterial_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectSearch_viewer">;
    readonly " $refType": "SbSharedRefineMenuFilterMaterial_viewer";
};
export type SbSharedRefineMenuFilterMaterial_viewer$data = SbSharedRefineMenuFilterMaterial_viewer;
export type SbSharedRefineMenuFilterMaterial_viewer$key = {
    readonly " $data"?: SbSharedRefineMenuFilterMaterial_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterMaterial_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterMaterial_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'f1ee0f61f00d2c93120f509f2ef54cde';
export default node;
